'use client';

import { createTheme } from '@mui/material/styles';
import { koKR as coreLocale } from '@mui/material/locale';
import { koKR as dataGridLocale } from '@mui/x-data-grid/locales';
import { koKR as datePickerLocale } from '@mui/x-date-pickers/locales';
import { palette } from './palette';
import { typography } from './typography';

const theme = createTheme(
  {
    cssVariables: true,
    palette,
    typography,
    components: {
      // MuiAlert: {
      //   styleOverrides: {
      //     root: ({ ownerState }) => ({
      //       ...(ownerState.severity === 'info' && {
      //         backgroundColor: '#60a5fa',
      //       }),
      //     }),
      //   },
      // },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            '&.MuiButtonBase-root': {
              // fontFamily: notoSansKR.style.fontFamily,
              fontWeight: 500,
              textTransform: 'none',
            },
          },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        // lg: 1280,
        lg: 1180,
        xl: 1536,
      },
    },
  },
  datePickerLocale,
  dataGridLocale,
  coreLocale,
);

export default theme;
